package br.com.vvrefeicoes.portal.domain.model

data class MonthlyFinancials(
    val period: MonthPeriod,
    val revenueCents: Long,
    val expenseCents: Long,
) {
    val resultCents: Long
        get() = revenueCents - expenseCents

    val profitPercent: Double
        get() = if (revenueCents == 0L) 0.0 else resultCents.toDouble() / revenueCents * 100
}
